import Loading from '../../../../Dashboards/Common/Loading';
import { AveragePeoplePerFamily } from './AveragePeoplePerFamily';
import { Families } from './Families';
import { Indicators } from './Indicators';
import { People } from './People';
import { useFamiliesChartsDataContext } from './hooks/useFamiliesChartsDataContext';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useFamiliesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="side-by-side-group">
                <Indicators />
                <div className="right-group-families">
                    <People />
                </div>
            </div>
            <div className="charts-side-by-side-dashboards">
                <AveragePeoplePerFamily />
                <Families />
            </div>
        </>
    );
};
